module.exports = __webpack_public_path__ + "img/9.e40c880.jpg";